import { render, staticRenderFns } from "./view.general.vue?vue&type=template&id=19f9158f&"
import script from "./view.general.vue?vue&type=script&lang=js&"
export * from "./view.general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports